import React, { useState } from 'react';
import { Navigation } from '../Navigation';
import { MentorAdvisorSurvey } from '../MentorAdvisorSurvey';
import { motion } from 'framer-motion';
export function MentorSurveyPage() {
  const [showSurvey, setShowSurvey] = useState(true);
  return <div className="min-h-screen bg-gradient-to-br from-[#B5EAD7] to-[#C5F467]" data-id="element-1001">
      <Navigation data-id="element-1002" />

      {showSurvey && <MentorAdvisorSurvey onClose={() => setShowSurvey(false)} data-id="element-1003" />}

      {!showSurvey && <div className="pt-24 pb-12 px-4" data-id="element-1004">
          <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="max-w-2xl mx-auto text-center" data-id="element-1005">
            <div className="bg-white rounded-[16px] p-12 shadow-xl" data-id="element-1006">
              <h1 className="text-[#1A3D3A] mb-4" style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: '48px',
            fontWeight: 500,
            lineHeight: 1.2
          }} data-id="element-1007">
                Thank You for Your Time
              </h1>
              <p className="text-[#3D5654] mb-6" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '18px',
            lineHeight: 1.7
          }} data-id="element-1008">
                Your perspective as a coach or advisor is invaluable. Having
                witnessed many partnerships, your insights reveal patterns that
                founders often miss. This research will help strengthen
                cofounder relationships across the ecosystem.
              </p>
              <p className="text-[#3D5654] mb-8" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '16px',
            lineHeight: 1.6
          }} data-id="element-1009">
                Your progress has been automatically saved. You can return
                anytime to complete the survey where you left off.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1010">
                <button onClick={() => setShowSurvey(true)} className="px-8 py-3 bg-[#1A3D3A] text-white rounded-lg hover:opacity-90 transition-all" style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: '14px',
              fontWeight: 600,
              letterSpacing: '0.5px'
            }} data-id="element-1011">
                  Resume Survey
                </button>
                <a href="/" className="px-8 py-3 bg-white border-2 border-[#1A3D3A] text-[#1A3D3A] rounded-lg hover:bg-[#F8FAF9] transition-all" style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: '14px',
              fontWeight: 600,
              letterSpacing: '0.5px'
            }} data-id="element-1012">
                  Return Home
                </a>
              </div>

              <p className="text-[#3D5654] mt-8 text-sm" style={{
            fontFamily: "'DM Sans', sans-serif",
            opacity: 0.7
          }} data-id="element-1013">
                Questions? Email us at{' '}
                <a href="mailto:info@cofounder.fit" className="text-[#1A3D3A] underline hover:opacity-70 transition-opacity" data-id="element-1014">
                  info@cofounder.fit
                </a>
              </p>
            </div>
          </motion.div>
        </div>}
    </div>;
}